import { BodyText, Flex } from '@utilitywarehouse/hearth-react';
import { useEffect, useRef } from 'react';

import { DialogID, useDialog } from '@components/Dialog';
import { UpdatingModal } from '@components/UpdatingModal';
import { DetailsBasket } from '@features/details/Basket';
import {
  AppointmentParticipantType,
  BundleBasketFragment,
} from '@generated/gql/graphql';
import { useBasketQuery } from '@hooks/useBasketQuery';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { useTrackingContextRefresh } from '@tracking/hooks';
import { getCashbackSavingsValue } from '@utils/formatBasket/cashback';

import { SaveForm } from './SaveForm';
import { useSaveForLaterForm } from './useSaveForLaterForm';

const SaveForLater = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const { basketId } = useBasketContext();
  const { appointment } = useAppointmentContext();
  const partnerIDs = appointment?.participants
    .filter(
      (p) =>
        p.type === AppointmentParticipantType.Partner ||
        p.type === AppointmentParticipantType.SupportingPartner
    )
    .map((p) => p.partnerId)
    .filter((id): id is string => !!id);
  const { handleSubmit, isSaving } = useSaveForLaterForm(basketId, partnerIDs);
  const { basketData, isLoading, error } = useBasketQuery();
  const updatingDialog = useDialog(DialogID.UPDATING_BUNDLE);

  // Ensures that the tracking context is set after page refresh
  useTrackingContextRefresh()(basketData, isLoading);

  useEffect(() => {
    updatingDialog.setOpen(isSaving);
  }, [isSaving, updatingDialog]);

  return (
    <>
      <div className="wrapper">
        <Flex spacing="xl" paddingBottom={{ mobile: '300', desktop: '600' }}>
          <Flex spacing="xl" direction="column" maxWidth="680px">
            <BodyText>
              Give us your email address or mobile number, and we’ll send you a
              link so you can pick up where you left off.
            </BodyText>

            <SaveForm
              ref={formRef}
              isLoading={isSaving}
              onSubmit={handleSubmit}
            />
          </Flex>
          <DetailsBasket
            loading={isLoading}
            cashbackSavingsValue={getCashbackSavingsValue(
              basketData?.cashbackCalculatorDetails ?? null
            )}
            error={error}
            basket={basketData?.basket as BundleBasketFragment}
            isTrackingEnabled
          />
        </Flex>
      </div>

      <UpdatingModal heading="Saving your quote..." />
    </>
  );
};

export { SaveForLater };
